/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { useEffect, useRef } from 'react'
import { FormikProps } from 'formik'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Lightbox } from '@nexigendigital/nxui'
import { useAppSelector } from 'store/hooks'

import NewPaymentMethodForm from 'containers/shop/checkout/form/newPaymentMethodForm'

/**********************************************************************************************************
 *   INTERFACE
 **********************************************************************************************************/
interface Props {
    status: boolean,
    close: () => void
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function NewPaymentMethodLightbox({ status, close }: Props) {
    const formRef = useRef<FormikProps<{ cardholder: string, cardNumber: string, expiry: string }>>(null)
    const { savePaymentMethodStatus } = useAppSelector((state) => state.billing)

    const handleSubmit = () => {
        if (formRef.current) {
            formRef.current.handleSubmit()
        }
    }

    useEffect(() => {
        if (savePaymentMethodStatus === 'success') {
            close()
        }
    }, [close, savePaymentMethodStatus])

    /*   RENDER COMPONENT
    **********************************************************************************************************/
    return (
        <Lightbox
            title={'Add New Payment Method'}
            content={<NewPaymentMethodForm form={formRef}/>}
            conditions={{ state: status, action: () => close() }}
            actions={[
                {
                    label: 'Back',
                    color: 'flat',
                    func: () => close()
                },
                {
                    label: 'Add',
                    color: 'primary',
                    type: 'submit',
                    loading: savePaymentMethodStatus === 'loading' ? 'Adding' : false,
                    func: () => handleSubmit()
                }
            ]}
        />
    )
}
